import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link, router, usePage } from '@inertiajs/react'
import Button from '../../components/Button'

const ROLE_LABELS = { member: 'Medlem', admin: 'Lagadmin' }

export default function TeamsShow({ team, members }) {
  const { auth } = usePage().props
  const isOrgAdmin = auth.user?.org_admin

  function removeMember(userId, name) {
    if (!confirm(`Ta bort ${name} från det här laget?`)) return
    router.delete(`/teams/${team.id}/members/${userId}`)
  }

  function toggleRole(userId, currentRole) {
    const newRole = currentRole === 'admin' ? 'member' : 'admin'
    router.patch(`/teams/${team.id}/members/${userId}`, {
      team_membership: { role: newRole }
    })
  }

  function deleteTeam() {
    if (!confirm('Ta bort det här laget? Alla medlemmar tas bort.')) return
    router.delete(`/teams/${team.id}`)
  }

  return (
    <AuthenticatedLayout>
      <div className="space-y-8">
        <div className="flex justify-between items-start">
          <div>
            <Link href="/teams" className="text-sm text-indigo-600 hover:underline">← Lag</Link>
            <h1 className="text-2xl font-bold text-gray-900 mt-2">{team.name}</h1>
          </div>
          {isOrgAdmin && (
            <div className="flex gap-2">
              <Link href={`/teams/${team.id}/edit`}>
                <Button variant="secondary">Redigera</Button>
              </Link>
              <Button variant="danger" onClick={deleteTeam}>Ta bort</Button>
            </div>
          )}
        </div>

        {/* Members */}
        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Medlemmar</h2>
          <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
            {members.length === 0 && (
              <p className="px-4 py-8 text-center text-gray-500 text-sm">Inga medlemmar ännu.</p>
            )}
            {members.map(m => (
              <div key={m.id} className="flex items-center justify-between px-4 py-3">
                <div>
                  <p className="font-medium text-gray-900">{m.name}</p>
                  <p className="text-sm text-gray-500">{m.email}</p>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${m.role === 'admin' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-600'}`}>
                    {ROLE_LABELS[m.role]}
                  </span>
                  {isOrgAdmin && (
                    <>
                      <button
                        onClick={() => toggleRole(m.id, m.role)}
                        className="text-sm text-indigo-600 hover:underline"
                      >
                        Gör till {m.role === 'admin' ? 'medlem' : 'admin'}
                      </button>
                      <button
                        onClick={() => removeMember(m.id, m.name)}
                        className="text-sm text-red-600 hover:underline"
                      >
                        Ta bort
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Invitations */}
        <div>
          <div className="flex justify-between items-center mb-3">
            <h2 className="text-lg font-semibold text-gray-900">Inbjudningslänk</h2>
            <Link href={`/teams/${team.id}/invitations/new`}>
              <Button>Skapa inbjudningslänk</Button>
            </Link>
          </div>
          <Link
            href={`/teams/${team.id}/invitations`}
            className="text-sm text-indigo-600 hover:underline"
          >
            Visa alla inbjudningslänkar →
          </Link>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
